import {Component, attr} from "../Component";
import {element} from "../CustomElement";
import {isCrawler} from "../../utils/crawler";

import {Timer} from "../../utils/Timer";
import {Rect} from "../../utils/Rect";

export interface LazyImageProps extends JSX.HTMLAttributes {
	dataSrc: string;
	fit?: boolean;
	cover?: boolean;
	contain?: boolean;
	onload?: any;
	disableLazyLoading?: boolean;
}

export const SCREEN_RECT_OFFSET = 0;

@element("flipp-lazy-image", "img")
export class LazyImage extends Component<LazyImageProps, {}> {
	@attr dataSrc: string;
	@attr fit: boolean;
	@attr disableLazyLoading: boolean;

	private _scrollDebouncer = new Timer(10,
			this.loadImageIfInViewport, this);

	onAttach() {
		window.addEventListener("scroll", this._handleViewportChange, true);
		window.addEventListener("resize", this._handleViewportChange, true);

		this.loadImageIfInViewport();
	}

	onDetach() {
		this._unbindEvents();
	}

	onRender() {
		this.loadImageIfInViewport();
		this.loadForCrawler();
	}


	private isInViewport() {
		let screenRect = new Rect(0, 0, window.innerWidth, window.innerHeight + SCREEN_RECT_OFFSET);
		let boundingRect = this.getBoundingClientRect();

		return Rect.intersects(screenRect, boundingRect);
	}

	private loadImageIfInViewport() {
		if (this.disableLazyLoading) {
			this.src = this.dataSrc;
			return;
		}
		if (isCrawler()) {
			return;
		}
		const isDisplayed = this.attached && (this.offsetParent !== null);

		if (isDisplayed && this.isInViewport()) {
			this.src = this.dataSrc;
			this._unbindEvents();
		}
	}

	private _handleViewportChange = (e: Event) => {
		this._scrollDebouncer.reset();
	}

	private _unbindEvents() {
		window.removeEventListener("scroll", this._handleViewportChange, true);
		window.removeEventListener("resize", this._handleViewportChange, true);
	}

	private loadForCrawler() {
		if (isCrawler() && !this.src) {
			this.src = this.dataSrc;
		}
	}
}
